import { render, staticRenderFns } from "./feedback-wrapper.vue?vue&type=template&id=f9d36a1e&scoped=true&"
import script from "./feedback-wrapper.vue?vue&type=script&lang=js&"
export * from "./feedback-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./feedback-wrapper.vue?vue&type=style&index=0&id=f9d36a1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d36a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d36a1e')) {
      api.createRecord('f9d36a1e', component.options)
    } else {
      api.reload('f9d36a1e', component.options)
    }
    module.hot.accept("./feedback-wrapper.vue?vue&type=template&id=f9d36a1e&scoped=true&", function () {
      api.rerender('f9d36a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/feedback-wrapper/feedback-wrapper.vue"
export default component.exports